// import React, { Component, useState } from "react";
import React, { useState, useEffect } from "react";
import Alert from "view/component/Alert";
import "react-tabs/style/react-tabs.css";
import apiService from "apiService.js";
import printJS from "print-js";
import { DetilPxContext } from "../../context";
import ButtonPrint from "./PrintButton";
import ALERT, { toast } from "../component/Alert";

const KajianAwal = (props) => {
  const [kajian, setKajian] = useState([]);
  const [result, setResult] = useState({});

  const onChange = (e) => {
    let id = e.target.name;
    let value = e.target.value;

    setResult({
      ...result,
      ["list_" + id]: value,
    });
  };

  const onChangeList = (e) => {
    let id = e.target.name;
    let value = e.target.value;

    setResult({
      ...result,
      ["list_list_" + id]: value,
    });
  };

  const handleRadioList = (e) => {
    let id = e.target.name;
    let value = e.target.id;
    let resval = value.substr(6);
    setResult({
      ...result,
      ["list_list_" + id]: resval,
    });
  };

  const handleRadio = (e) => {
    let id = e.target.name;
    let value = e.target.value;

    setResult({
      ...result,
      ["list_" + id]: value,
    });

    console.log(result, id, value);
  };

  const onChangeCx = (e) => {
    let id = e.target.name;
    let value = e.target.value;

    setResult({
      ...result,
      ["list_" + id]: value,
    });
    console.log(result);
  };

  const storeKajianAwal = async () => {
    let userId = 1;
    let visitId = props.detilPx.id;
    let list = result;

    const data = {
      user_id: userId,
      visit_id: visitId,
      result: list,
    };
    let res = await apiService.post(`management/kajian_awal/answer`, data);

    if (res.code === 200) {
      // console.log("success");
      if (res.code === 200) {
        ALERT("success", "Berhasil Menyimpan Data ");
      } else {
        ALERT("error", "gagal menyimpan data");
      }
    }
  };

  const fetchKajian = async () => {
    // let res = await apiService.get(`management/kajian_awal/result/1378/umum`);
    let res = await apiService.get(
      `management/kajian_awal/result/${props.detilPx.id}/dokter`
    );
    if (res) {
      setKajian(res.data);
      answer(res.data);
    }
  };

  useEffect(() => {
    answer(fetchKajian);
  }, [result]);

  useEffect(() => {
    fetchKajian();
  }, [kajian.length]);

  const answer = (data) => {
    if (data.length !== 0) {
      let obj = {};
      // console.log(data);
      for (let x = 0; x < data.length; x++) {
        const element = data[x];
        for (let y = 0; y < element.ref_kajian.length; y++) {
          const el = element.ref_kajian[y];
          for (let i = 0; i < el.list.length; i++) {
            const res = el.list[i];
            if (res.result) {
              obj = {
                ...obj,
                [res.identifier]: res.result?.result,
              };
            }

            if (res.list_list) {
              for (let j = 0; j < res.list_list.length; j++) {
                const lo = res.list_list[j];
                if (lo.result) {
                  obj = {
                    ...obj,
                    [lo.identifier]: lo.result?.result,
                  };
                }
              }
            }
          }
        }
      }
      // console.log(obj)
      setResult(obj);
    } else {
      return 0;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    storeKajianAwal();
  };

  const generateForm = (questions) => {
    let element = [];
    for (let i = 0; i < questions.length; i++) {
      if (questions[i].type == "text") {
        element.push(
          <div key={"text" + i}>
            <div className="form-group">
              <div className="row">
                <div className="col-md-5">
                  <label className="form-control-label">
                    {questions[i].label}
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    type="text"
                    name={questions[i].id}
                    className="form-control form-control-sm"
                    onChange={(e) => onChange(e)}
                    value={result["list_" + questions[i].id]}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      } else if (questions[i].type == "radio") {
        element.push(
          <div>
            <div className="form-group">
              <div className="custom-control custom-radio mb-2 col-md-6">
                <input
                  id={questions[i].id}
                  type="radio"
                  name={questions[i].ref_kajian_awal_id}
                  className="custom-control-input"
                  onChange={(e) => handleRadio(e)}
                  // checked={
                  //   result["list_" + questions[i]?.id] === questions[i]?.label
                  //     ? true
                  //     : false
                  // }
                  // value={questions[i].label}
                  value={result["list_" + questions[i].ref_kajian_awal_id]}
                />
                <label
                  className="custom-control-label ml-3 mr-n3"
                  htmlFor={questions[i].id}
                >
                  {questions[i].label}
                </label>
              </div>
            </div>
          </div>
        );
      } else if (questions[i].type == "parent") {
        let parent = [];
        for (let x = 0; x < questions[i].list_list.length; x++) {
          if (questions[i].list_list[x].type == "radio") {
            parent.push(
              <div key={`radio${x}${i}`}>
                <div className="custom-control custom-radio mb-2 col-md-6">
                  <input
                    id={`parent${questions[i].list_list[x].id}`}
                    type="radio"
                    name={questions[i].id}
                    className="custom-control-input"
                    onChange={(e) => handleRadioList(e)}
                    checked={
                      result["list_list_" + questions[i].list_list[x]?.id] ===
                      questions[i].list_list[x].id
                        ? true
                        : null
                    }
                    value={questions[i].list_list[x].label}
                  />
                  <label
                    className="custom-control-label ml-3 mr-n3"
                    htmlFor={`parent${questions[i].list_list[x].id}`}
                  >
                    {questions[i].list_list[x].label}
                  </label>
                </div>
              </div>
            );
          } else if (questions[i].list_list[x].type == "text") {
            parent.push(
              <div key={`text${x}${i}`}>
                <div className="mb-2 col-md-6">
                  <input
                    className="form-control form-control-sm"
                    id={questions[i].list_list[x].id}
                    type="text"
                    name={questions[i].id}
                    onChange={(e) => onChangeList(e)}
                    value={result["list_list_" + questions[i].list_list[x].id]}
                  />
                  <label className="ml-3 mr-n3">
                    {questions[i].list_list[x].label}
                  </label>
                </div>
              </div>
            );
          }
        }

        element.push(
          <div className="form-group" key={"parent" + i}>
            <div className="row">
              <div className="col-md-5">
                <label className="form-control-label">
                  {questions[i].label}
                </label>
              </div>
              <div className="col-md-7">{parent}</div>
            </div>
          </div>
        );
      } else if (questions[i].type == "checkbox") {
        element.push(
          <div className="form-group">
            <div className="row">
              <div className="custom-control custom-checkbox ml-3 col-md-5">
                <input
                  id={questions[i].id}
                  type="checkbox"
                  name={questions[i].id}
                  className="custom-control-input"
                  onChange={(e) => onChangeCx(e)}
                  checked={
                    result["list_" + questions[i]?.id] === questions[i]?.label
                      ? true
                      : false
                  }
                  value={questions[i].label}
                />
                <label
                  className="custom-control-label ml-2"
                  htmlFor={questions[i].id}
                >
                  {questions[i].label}
                </label>
              </div>
            </div>
          </div>
        );
      } else if (questions[i].type == "textarea") {
        element.push(
          <div key={"text" + i}>
            <div className="form-group">
              <div className="row">
                <div className="col-md-12">
                  <label className="form-control-label">
                    {questions[i].label}
                  </label>
                </div>
                <div className="col-md-12">
                  <textarea
                    type="text"
                    name={questions[i].id}
                    className="form-control form-control-sm"
                    onChange={(e) => onChange(e)}
                    value={result["list_" + questions[i].id]}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      }
    }
    return element;
  };

  return (
    <>
      <div className="card">
        <div className="card-header">
          <div className="row align-items-center">
            <div className="col row">
              <div className="col-md-3">
                <h4 className="h3 mb-0 mb-n5">Form Kajian Awal</h4>
              </div>
              <div className="col-md-7">
                <ButtonPrint
                  url={`/management/kajian_awal/print/dokter/${props.detilPx.id}`}
                  // url={`/management/kajian_awal/print/1378`}
                  buttonText="Print Kajian Awal"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row">
              {kajian.map((dat, index) => {
                let el = [];
                for (let i = 0; i < dat.ref_kajian.length; i++) {
                  el.push(
                    <div className="col-6" key={index + i}>
                      <label className="h4 mb-3 font-weight-bold">
                        {dat.ref_kajian[i].label}
                      </label>
                      {generateForm(dat.ref_kajian[i].list, i)}
                    </div>
                  );
                }
                return el;
              })}
            </div>
            <div className="text-right">
              <button type="submit" className="btn btn-primary btn-md mt-1">
                Simpan Data
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
export default KajianAwal;
